import React from "react";
import { FaTasks, FaClipboardCheck, FaChartLine, FaBullhorn, FaEye } from "react-icons/fa";

function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div className="col-lg-4 col-md-6 process-two-single">
      <div className="services-style-two-item fade-up-anim">
        <div className="top-info">
          <div className="icon" style={{ fontSize: "40px", color: "#007bff" }}>
            <Icon />
          </div>
          <h4><a>{title}</a></h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}

function CompleteListing() {
  const features = [
    {
      title: "Complete Listing Management",
      description: "Assistance with completing the application process, submitting required details, and following up with platform support to expedite listing.",
      icon: FaTasks,
    },
    {
      title: "Regulatory Compliance Review",
      description: "Ensuring all listing submissions meet CoinMarketCap and CoinGecko’s compliance standards for a smooth, hassle-free approval.",
      icon: FaClipboardCheck,
    },
    {
      title: "Analytics and Market Data Integration",
      description: "Integration of essential market data points, including price tracking, market cap, and trading volume, to support real-time visibility and analysis.",
      icon: FaChartLine,
    },
    {
      title: "Marketing Boost & Community Engagement",
      description: "Strategic promotional support to elevate your token’s reach, combining social media, PR, and influencer engagement.",
      icon: FaBullhorn,
    },
    {
      title: "Post-Listing Monitoring",
      description: "Continuous performance tracking, updates, and improvements to maintain token ranking and visibility.",
      icon: FaEye,
    },
  ];

  return (
    <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h4 className="sub-title">What we do</h4>
              <h2 className="title split-text-right split-text-in-right">
                Key Features of Our CoinMarketCap & CoinGecko Listing Service
              </h2>
            </div>
          </div>
        </div>
        <div className="container fade-up-anim">
          <div className="row">
            {features.map((feature, idx) => (
              <FeatureCard key={idx} {...feature} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompleteListing;